import React, { useContext } from 'react';
import UserProvider from '../../context/UserContext';
import { CardJoinConfirmation } from '../card/CardJoinConfirmation';
import { CardHowItWorks } from '../card/CardHowItWorks';
import '../../waitlist.css'


export const MainWaitlist = () => {

    const Context = useContext(UserProvider.context);

    const handleShowHowItWorks = () => {
        Context.setshowHowItWorks(!Context.showHowItWorks)
    }

    const handleShowEnterWaitlist = () => {
        Context.setEnterWaitlist(!Context.showEnterWaitlist)
    }

    return(

        <div className="center-container-holder">
            <div className="centered-container"> 
                    {
                        Context.showEnterWaitlist &&

                        <div className="center-holder">    
                            <CardJoinConfirmation/>
                        </div>
                    }
                    {
                        Context.showHowItWorks &&
                        
                        <div className="center-holder">
                            <CardHowItWorks/>
                        </div>
                    }
                    {   
                        !Context.showHowItWorks &&
                        !Context.showEnterWaitlist &&

                        <div className="center-holder">
                            <div className="title-holder">
                                <h1 className="title"><b>Join us!</b></h1>
                            </div>
                            <div className="subtitle-holder">
                                <h3 className="subtitle">Get the opportunity to purchase Infinit.</h3>
                            </div>
                            <div className="waitlist-actions-holder">
                                <div className="waitlist-button-holder">
                                    <button className="waitlist-join-button waitlist-button" onClick={handleShowEnterWaitlist}>Enter the waitlist<i className="fas fa-angle-right"/></button>
                                </div>
                                <div className="howitworks-button-holder">
                                    <button className="howitworks-join-button howitworks-button" onClick={handleShowHowItWorks}>How it works?</button>
                                </div>
                            </div>
                        </div>
                    }

            </div>
        </div>
    )
}
